import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const ChangeEtat = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/changeEtat`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}

const ChangeStatus = async (data) => {
  return await axios.post(`${BASE_URL}/api/restaurant/changeStatus`, data, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}
const AfficheReservationResto = async (idRestaurant) => {
  return await axios.get(`${BASE_URL}/api/restaurant/afficheReservation/${idRestaurant}`, {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
    }
  });
}


export { AfficheReservationResto, ChangeEtat, ChangeStatus }